// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23ffffff%27 fill-opacity=%270.05%27%3E%3Ccircle cx=%2730%27 cy=%2730%27 r=%272%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  position: relative;
  overflow: hidden;
}

.reset-password-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  animation: float 20s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}

/* Header */
/* .reset-password-container .login-header {
  position: absolute;
  top: 2rem;
  left: 2rem;
  z-index: 10;
} */

.login-logo-link {
  text-decoration: none;
  color: inherit;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.reset-password-container .logo-icon {
  width: 40px;
  height: 40px;
  background: #f8fafc;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.reset-logo-icon {
  font-size: 1.5rem;
  color: #ffffff;
}

.reset-logo-text {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Main Content */
.reset-password-content {
  display: flex;
  min-height: 100vh;
  position: relative;
  z-index: 5;
}

/* Left Side - Illustration */
.reset-password-left {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.illustration-container {
  text-align: center;
  max-width: 500px;
}

.sync-animation {
  margin-bottom: 2rem;
  position: relative;
}

.sync-icon {
  display: inline-block;
  color: rgba(255, 255, 255, 0.9);
  animation: rotate 3s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.illustration-text h2 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.illustration-text p {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Right Side - Form */
.reset-password-right {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

/* Update form container */
.form-container {
  width: 100%;
  max-width: 600px; /* Increased width for side-by-side layout */
  background: #ffffff;
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.form-header {
  text-align: center;
  margin-bottom: 2rem;
}

.form-header h1 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
}

.form-header p {
  color: #6b7280;
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 0;
}

/* Form Styles */
.reset-password-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Password fields row */
.password-fields-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 0.5rem;
}

/* Form styling updates */
.form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}

.required {
  color: #ef4444;
}

.form-input {
  width: 100%;
  padding: 0.875rem 1rem;
  padding-right: 3rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.2s ease;
  background: #ffffff;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-input.error {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.form-input::placeholder {
  color: #9ca3af;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-toggle {
  position: absolute;
  right: 1rem;
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: color 0.2s;
}

.password-toggle:hover {
  color: #374151;
}

/* Error Messages */
.error-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #dc2626;
  font-size: 0.9rem;
}

.error-icon {
  font-size: 1.1rem;
}

.field-error {
  color: #ef4444;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}

/* Password hint */
.password-hint {
  color: #6b7280;
  font-size: 0.875rem;
  margin-bottom: 1.5rem;
  text-align: left;
}

/* Password Requirements - Checkbox Style */
.password-requirements {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.password-requirements h4 {
  margin: 0 0 1rem 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #374151;
}

.requirements-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.requirement-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: #6b7280;
  transition: color 0.2s ease;
}

.requirement-item.valid {
  color: #059669;
}

.requirement-checkbox {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.requirement-item:not(.valid) .requirement-checkbox {
  border: 2px solid #d1d5db;
  background: #ffffff;
}

.requirement-item.valid .requirement-checkbox {
  background: #059669;
  color: #ffffff;
  border: 2px solid #059669;
}

.checkbox-empty {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background: transparent;
}

/* Security Tips */
.security-tips {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.security-tips h4 {
  margin: 0 0 1rem 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e40af;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.tips-content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.tip-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: #1e40af;
  line-height: 1.5;
}

.tip-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.125rem;
  color: #3b82f6;
}

/* Button styling */
.reset-button {
  width: 100%;
  padding: 0.875rem 2rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.reset-button:hover:not(:disabled) {
  background: #2563eb;
}

.reset-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Form footer */
.form-footer {
  text-align: center;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}

.form-footer p {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}

.login-link {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.login-link:hover {
  color: #1d4ed8;
}

/* Success Modal */
.reset-password-page {
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reset-password-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.reset-password-modal {
  position: relative;
  z-index: 10;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 3rem;
  max-width: 500px;
  margin: 2rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.success-content {
  text-align: center;
}

.success-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  color: white;
  animation: successPulse 2s ease-in-out infinite;
}

@keyframes successPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.success-content h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
}

.success-content p {
  color: #6b7280;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.loading-animation {
  margin: 2rem 0;
}

.redirect-info {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
}

.redirect-info p {
  color: #9ca3af;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.manual-redirect {
  display: inline-block;
  color: #3b82f6;
  text-decoration: none;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border: 1px solid #3b82f6;
  border-radius: 8px;
  transition: all 0.2s;
}

.manual-redirect:hover {
  background: #3b82f6;
  color: white;
}

/* Token validation states */
.token-validation-loading,
.token-error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  position: relative;
  z-index: 5;
}

.loading-content,
.error-content {
  text-align: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 3rem;
  max-width: 500px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.loading-content p {
  color: #6b7280;
  font-size: 1.1rem;
  margin-top: 1rem;
}

.error-content {
  max-width: 600px;
}

.error-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  color: white;
}

.error-content h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
}

.error-content p {
  color: #6b7280;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.error-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 0.875rem 2rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
}

.btn-primary {
  background: #3b82f6;
  color: white;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-secondary {
  background: #e5e7eb;
  color: #374151;
}

.btn-secondary:hover {
  background: #d1d5db;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .reset-password-content {
    flex-direction: column;
  }

  .reset-password-left {
    flex: none;
    padding: 1rem;
  }

  .illustration-text h2 {
    font-size: 2rem;
  }

  .illustration-text p {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .password-fields-row {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  /* .reset-password-container .login-header {
    top: 1rem;
    left: 1rem;
  } */

  .reset-logo-text {
    font-size: 1.25rem;
  }

  .reset-password-left {
    display: none;
  }

  .reset-password-right {
    padding: 1rem;
  }

  .form-container {
    max-width: 100%;
    padding: 2rem;
  }

  .form-header h1 {
    font-size: 1.75rem;
  }

  .reset-password-modal {
    margin: 1rem;
    padding: 2rem;
  }

  .success-content h2 {
    font-size: 1.75rem;
  }

  .requirements-list {
    gap: 0.5rem;
  }

  .tips-content {
    gap: 0.5rem;
  }

  .error-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }

  .loading-content,
  .error-content {
    padding: 2rem;
    margin: 1rem;
  }

  .error-content h2 {
    font-size: 1.75rem;
  }
}

@media (max-width: 480px) {
  .form-container {
    padding: 1.5rem;
  }

  .password-requirements,
  .security-tips {
    padding: 1rem;
  }

  .form-input {
    padding: 0.875rem;
  }

  .reset-button {
    padding: 0.875rem 1.5rem;
  }
}

/* Focus states for accessibility */
.form-input:focus,
.reset-button:focus,
.password-toggle:focus,
.login-link:focus,
.manual-redirect:focus,
.btn:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Print styles */
@media print {
  .reset-password-container {
    background: white;
  }

  .reset-password-container::before {
    display: none;
  }

  .sync-animation {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResetPassword/ResetPassword.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,8EAA8E;EAC9E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAA6Q;EAC7Q,yCAAyC;AAC3C;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,WAAW;AACX;;;;;GAKG;;AAEH;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,gBAAgB,EAAE,4CAA4C;EAC9D,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;;EAEE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;;KAGG;;EAEH;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;;;;;;EAME,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".reset-password-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  position: relative;\n  overflow: hidden;\n}\n\n.reset-password-container::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n  animation: float 20s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%,\n  100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-20px);\n  }\n}\n\n/* Header */\n/* .reset-password-container .login-header {\n  position: absolute;\n  top: 2rem;\n  left: 2rem;\n  z-index: 10;\n} */\n\n.login-logo-link {\n  text-decoration: none;\n  color: inherit;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.reset-password-container .logo-icon {\n  width: 40px;\n  height: 40px;\n  background: #f8fafc;\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.reset-logo-icon {\n  font-size: 1.5rem;\n  color: #ffffff;\n}\n\n.reset-logo-text {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Main Content */\n.reset-password-content {\n  display: flex;\n  min-height: 100vh;\n  position: relative;\n  z-index: 5;\n}\n\n/* Left Side - Illustration */\n.reset-password-left {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.illustration-container {\n  text-align: center;\n  max-width: 500px;\n}\n\n.sync-animation {\n  margin-bottom: 2rem;\n  position: relative;\n}\n\n.sync-icon {\n  display: inline-block;\n  color: rgba(255, 255, 255, 0.9);\n  animation: rotate 3s linear infinite;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.illustration-text h2 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 1rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.illustration-text p {\n  font-size: 1.2rem;\n  color: rgba(255, 255, 255, 0.8);\n  line-height: 1.6;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n/* Right Side - Form */\n.reset-password-right {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n/* Update form container */\n.form-container {\n  width: 100%;\n  max-width: 600px; /* Increased width for side-by-side layout */\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 2.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n}\n\n.form-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.form-header h1 {\n  font-size: 1.75rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0.5rem;\n}\n\n.form-header p {\n  color: #6b7280;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  margin-bottom: 0;\n}\n\n/* Form Styles */\n.reset-password-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* Password fields row */\n.password-fields-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 0.5rem;\n}\n\n/* Form styling updates */\n.form-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n\n.required {\n  color: #ef4444;\n}\n\n.form-input {\n  width: 100%;\n  padding: 0.875rem 1rem;\n  padding-right: 3rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  transition: all 0.2s ease;\n  background: #ffffff;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-input.error {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.form-input::placeholder {\n  color: #9ca3af;\n}\n\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 1rem;\n  background: none;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: color 0.2s;\n}\n\n.password-toggle:hover {\n  color: #374151;\n}\n\n/* Error Messages */\n.error-message {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  color: #dc2626;\n  font-size: 0.9rem;\n}\n\n.error-icon {\n  font-size: 1.1rem;\n}\n\n.field-error {\n  color: #ef4444;\n  font-size: 0.85rem;\n  margin-top: 0.25rem;\n}\n\n/* Password hint */\n.password-hint {\n  color: #6b7280;\n  font-size: 0.875rem;\n  margin-bottom: 1.5rem;\n  text-align: left;\n}\n\n/* Password Requirements - Checkbox Style */\n.password-requirements {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.password-requirements h4 {\n  margin: 0 0 1rem 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.requirements-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.requirement-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 0.875rem;\n  color: #6b7280;\n  transition: color 0.2s ease;\n}\n\n.requirement-item.valid {\n  color: #059669;\n}\n\n.requirement-checkbox {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.2s ease;\n}\n\n.requirement-item:not(.valid) .requirement-checkbox {\n  border: 2px solid #d1d5db;\n  background: #ffffff;\n}\n\n.requirement-item.valid .requirement-checkbox {\n  background: #059669;\n  color: #ffffff;\n  border: 2px solid #059669;\n}\n\n.checkbox-empty {\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n  background: transparent;\n}\n\n/* Security Tips */\n.security-tips {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-top: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.security-tips h4 {\n  margin: 0 0 1rem 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #1e40af;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.tips-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.tip-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  font-size: 0.875rem;\n  color: #1e40af;\n  line-height: 1.5;\n}\n\n.tip-icon {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n  color: #3b82f6;\n}\n\n/* Button styling */\n.reset-button {\n  width: 100%;\n  padding: 0.875rem 2rem;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.reset-button:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.reset-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Form footer */\n.form-footer {\n  text-align: center;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.form-footer p {\n  color: #6b7280;\n  font-size: 0.875rem;\n  margin: 0;\n}\n\n.login-link {\n  color: #3b82f6;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s;\n}\n\n.login-link:hover {\n  color: #1d4ed8;\n}\n\n/* Success Modal */\n.reset-password-page {\n  min-height: 100vh;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.reset-password-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n}\n\n.background-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.reset-password-modal {\n  position: relative;\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 3rem;\n  max-width: 500px;\n  margin: 2rem;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.success-content {\n  text-align: center;\n}\n\n.success-icon {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 2rem;\n  color: white;\n  animation: successPulse 2s ease-in-out infinite;\n}\n\n@keyframes successPulse {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n.success-content h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 1rem;\n}\n\n.success-content p {\n  color: #6b7280;\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n}\n\n.loading-animation {\n  margin: 2rem 0;\n}\n\n.redirect-info {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.redirect-info p {\n  color: #9ca3af;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n}\n\n.manual-redirect {\n  display: inline-block;\n  color: #3b82f6;\n  text-decoration: none;\n  font-weight: 600;\n  padding: 0.5rem 1rem;\n  border: 1px solid #3b82f6;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.manual-redirect:hover {\n  background: #3b82f6;\n  color: white;\n}\n\n/* Token validation states */\n.token-validation-loading,\n.token-error-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  position: relative;\n  z-index: 5;\n}\n\n.loading-content,\n.error-content {\n  text-align: center;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 3rem;\n  max-width: 500px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.loading-content p {\n  color: #6b7280;\n  font-size: 1.1rem;\n  margin-top: 1rem;\n}\n\n.error-content {\n  max-width: 600px;\n}\n\n.error-icon {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 2rem;\n  color: white;\n}\n\n.error-content h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 1rem;\n}\n\n.error-content p {\n  color: #6b7280;\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n}\n\n.error-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.btn {\n  padding: 0.875rem 2rem;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n}\n\n.btn-primary {\n  background: #3b82f6;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #2563eb;\n}\n\n.btn-secondary {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.btn-secondary:hover {\n  background: #d1d5db;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .reset-password-content {\n    flex-direction: column;\n  }\n\n  .reset-password-left {\n    flex: none;\n    padding: 1rem;\n  }\n\n  .illustration-text h2 {\n    font-size: 2rem;\n  }\n\n  .illustration-text p {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .password-fields-row {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  /* .reset-password-container .login-header {\n    top: 1rem;\n    left: 1rem;\n  } */\n\n  .reset-logo-text {\n    font-size: 1.25rem;\n  }\n\n  .reset-password-left {\n    display: none;\n  }\n\n  .reset-password-right {\n    padding: 1rem;\n  }\n\n  .form-container {\n    max-width: 100%;\n    padding: 2rem;\n  }\n\n  .form-header h1 {\n    font-size: 1.75rem;\n  }\n\n  .reset-password-modal {\n    margin: 1rem;\n    padding: 2rem;\n  }\n\n  .success-content h2 {\n    font-size: 1.75rem;\n  }\n\n  .requirements-list {\n    gap: 0.5rem;\n  }\n\n  .tips-content {\n    gap: 0.5rem;\n  }\n\n  .error-actions {\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n  }\n\n  .loading-content,\n  .error-content {\n    padding: 2rem;\n    margin: 1rem;\n  }\n\n  .error-content h2 {\n    font-size: 1.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .form-container {\n    padding: 1.5rem;\n  }\n\n  .password-requirements,\n  .security-tips {\n    padding: 1rem;\n  }\n\n  .form-input {\n    padding: 0.875rem;\n  }\n\n  .reset-button {\n    padding: 0.875rem 1.5rem;\n  }\n}\n\n/* Focus states for accessibility */\n.form-input:focus,\n.reset-button:focus,\n.password-toggle:focus,\n.login-link:focus,\n.manual-redirect:focus,\n.btn:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n/* Print styles */\n@media print {\n  .reset-password-container {\n    background: white;\n  }\n\n  .reset-password-container::before {\n    display: none;\n  }\n\n  .sync-animation {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
